import { Box, Heading, Text } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'
import Chart from 'react-apexcharts'

import useHome from '@hook/shared/use-home'

import { parseCurrency } from '@helper/parseCurrency'

import ChartsLoading from '../Loading'

interface IActualSaleVersusBudgetedSalesChartsProps {
  empresas: Array<number>
}

const ActualSaleVersusBudgetedSalesCharts: FC<IActualSaleVersusBudgetedSalesChartsProps> =
  ({ empresas }) => {
    const { dataActualSales, loadingActualSales, getDataActualSales } =
      useHome()

    const chart = useMemo(() => {
      const hasData =
        dataActualSales.vendaOrcada === 0 && dataActualSales.vendaReal === 0

      return {
        options: {
          chart: {
            toolbar: {
              show: false
            },
            zoom: {
              enabled: false
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 8,
              dataLabels: {
                position: 'top'
              }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function (val: string) {
              return (
                'R$' +
                parseCurrency({
                  value: Number(val),
                  country: 'pt-br',
                  minFraction: 0,
                  maxFraction: 0
                })
              )
            },
            offsetY: -20,
            style: {
              fontSize: '12px',
              colors: ['#304758']
            }
          },
          noData: {
            text: 'Não há dados suficiente para completar o gráfico'
          },
          xaxis: {
            categories: ['Valores'],
            labels: {
              show: false
            }
          },
          grid: {
            show: !hasData
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          tooltip: {
            x: {
              show: true,
              formatter: undefined
            },
            y: {
              formatter: (val: any) =>
                'R$' +
                parseCurrency({
                  value: Number(val),
                  country: 'pt-br',
                  minFraction: 0,
                  maxFraction: 0
                }),

              title: {
                formatter: (x: any) => x
              }
            }
          }
        },
        series: hasData
          ? []
          : [
              {
                name: 'Orçado',
                data: [dataActualSales.vendaOrcada]
              },
              {
                name: 'Realizado',
                data: [dataActualSales.vendaReal]
              }
            ]
      }
    }, [dataActualSales.vendaOrcada, dataActualSales.vendaReal])

    useEffect(() => {
      if (
        dataActualSales.vendaOrcada === null &&
        dataActualSales.vendaReal === null
      ) {
        getDataActualSales(empresas)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [empresas])

    return (
      <Box p={6} bg="white" borderRadius="8px" boxShadow="sm">
        <Heading size="md">Venda Real x Venda Orçada</Heading>
        <Text fontSize="sm" color="gray.600" mb={6}>
          Venda acumulada do mês corrente
        </Text>
        <ChartsLoading isLoaded={!loadingActualSales}>
          <Chart
            options={chart.options}
            series={chart.series}
            type="bar"
            width="100%"
            height="320px"
          />
        </ChartsLoading>
      </Box>
    )
  }

export default ActualSaleVersusBudgetedSalesCharts
